"use client";
import * as React from "react";
import { useContext } from "react";

type PaginatedTableProps = {
  cols: TableProps["cols"];
  data: TableProps["data"];
  actions: TableProps["actions"];
  tableProps?: Pick<TableProps, "tableCaption" | "classNames">;
  showErrorComponent: boolean;
  errorMessage: string;
  emptyStateMessage: string;
};
import EmptyState from "../EmptyState/index";
import Table from "./index";
import { TableProps } from "../types";
import PaginateContext from "../Paginate/paginate.context";
import styles from "./index.module.css";

function PaginatedTable(props: PaginatedTableProps) {
  function showEmptyData() {
    return props.data.length === 0 && context.offset === 0;
  }

  function showNoMoreResults() {
    return props.data.length === 0 && context.offset > 0;
  }

  const context = useContext(PaginateContext);

  return (
    <>
      {!showEmptyData() ? (
        <>
          <div className={styles.tableContainer}>
            <Table
              cols={props.cols}
              data={props.data}
              actions={props.actions}
              noMoreResults={showNoMoreResults()}
              {...props.tableProps}
            />
          </div>
        </>
      ) : (
        <>
          <>
            {props.showErrorComponent ? (
              <EmptyState variant="error" title={props.errorMessage} />
            ) : null}
            {!props.showErrorComponent ? (
              <EmptyState title={props.emptyStateMessage} />
            ) : null}
          </>
        </>
      )}
    </>
  );
}

export default PaginatedTable;
